// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__qaFey","label":"styles_label__g4CCd","icon":"styles_icon__uf818"};